var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_850_3491)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 58,
    fill: "url(#paint0_radial_850_3491)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_3491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1879 66.3773C37.0282 66.3773 36.9883 66.2964 37.0682 66.1752L37.9065 65.0839C37.9864 64.9627 38.186 64.8818 38.3457 64.8818H52.5978C52.7575 64.8818 52.7975 65.0031 52.7176 65.1243L52.0389 66.1752C51.9591 66.2964 51.7595 66.4177 51.6397 66.4177L37.1879 66.3773Z",
    fill: "#00ACD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1597 70.095C31 70.095 30.9601 70.0142 31.0399 69.893L31.8783 68.8017C31.9581 68.6804 32.1577 68.5996 32.3174 68.5996H50.5219C50.6816 68.5996 50.7614 68.7209 50.7215 68.8421L50.4021 69.8121C50.3622 69.9738 50.2025 70.0546 50.0428 70.0546L31.1597 70.095Z",
    fill: "#00ACD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8208 73.8138C40.6611 73.8138 40.6212 73.6925 40.7011 73.5713L41.26 72.5609C41.3398 72.4396 41.4995 72.3184 41.6592 72.3184H49.6436C49.8033 72.3184 49.8831 72.4396 49.8831 72.6013L49.8033 73.5713C49.8033 73.733 49.6436 73.8542 49.5238 73.8542L40.8208 73.8138Z",
    fill: "#00ACD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26 65.6495C79.7449 66.2962 78.0283 66.7812 75.5531 67.4278C74.9543 67.5895 74.9143 67.6299 74.3953 67.0237C73.7965 66.3366 73.3574 65.892 72.519 65.4878C70.0039 64.2349 67.5687 64.5986 65.2931 66.0941C62.5784 67.8724 61.1811 70.4996 61.221 73.7733C61.261 77.0067 63.4567 79.6743 66.6105 80.1188C69.3252 80.4826 71.6008 79.5126 73.3973 77.4513C73.7566 77.0067 74.076 76.5217 74.4752 75.9559C73.038 75.9559 71.2415 75.9559 66.7702 75.9559C65.9319 75.9559 65.7322 75.4305 66.0117 74.7434C66.5307 73.4904 67.4888 71.3887 68.0477 70.3379C68.1675 70.0954 68.447 69.6912 69.0458 69.6912C71.0818 69.6912 78.5872 69.6912 83.5774 69.6912C83.4976 70.7825 83.4976 71.8737 83.3379 72.965C82.8988 75.875 81.8209 78.5426 80.0643 80.8868C77.1899 84.7264 73.4372 87.111 68.6865 87.7577C64.7741 88.2831 61.1412 87.5152 57.9474 85.0902C54.9932 82.8268 53.3165 79.8359 52.8773 76.1175C52.3583 71.7121 53.6358 67.7512 56.2707 64.2753C59.1052 60.5165 62.8579 58.1319 67.4489 57.2831C71.2016 56.596 74.7946 57.0406 78.0283 59.2636C80.1441 60.6782 81.6612 62.6182 82.6592 64.9624C82.8988 65.3261 82.7391 65.5282 82.26 65.6495Z",
    fill: "#00ACD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4742 88C91.8413 87.9191 88.5278 86.8683 85.7332 84.4433C83.3778 82.382 81.9007 79.7549 81.4216 76.6427C80.703 72.0756 81.9406 68.0339 84.6553 64.4367C87.5696 60.5567 91.0828 58.5358 95.8335 57.6871C99.9056 56.9596 103.738 57.3637 107.211 59.7483C110.365 61.9309 112.321 64.8813 112.84 68.7614C113.519 74.2177 111.962 78.6636 108.249 82.4628C105.614 85.1708 102.381 86.8683 98.668 87.6362C97.5901 87.8383 96.5122 87.8787 95.4742 88ZM104.976 71.6714C104.936 71.146 104.936 70.7418 104.856 70.3376C104.137 66.3363 100.504 64.073 96.7118 64.9622C92.9991 65.8109 90.6037 68.1955 89.7254 71.9948C89.0068 75.1473 90.5239 78.3403 93.3983 79.6336C95.594 80.6036 97.7897 80.4824 99.9056 79.3911C103.059 77.734 104.776 75.1473 104.976 71.6714Z",
    fill: "#00ACD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_850_3491",
    x: 0,
    y: 0,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_850_3491"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_850_3491",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72 72) rotate(85.4261) scale(54.5487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACD7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_3491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 31,
    fill: "white",
    transform: "translate(31 57)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/go.4a2223a961ab6de1fdb721462c342fa5.svg";
export { ForwardRef as ReactComponent };